export { PerformanceTimelineInstrumentation, DEFAULT_PERFORMANCE_TIMELINE_ENTRY_TYPES } from './instrumentation';
//# sourceMappingURL=index.js.map